import { MailToSystemAdminSupportLink } from '../../components/shared/MailToSystemAdminSupportLink';

export const RenderQueryTooManyResults = (maxRecordCount: number) => (
  <div className="container-fluid">
    <span>
      Your query returned more than {maxRecordCount.toLocaleString("en-US")} records. The request
      cannot be completed at this time. If you did not run this query by error, please send an email
      with the following information to <MailToSystemAdminSupportLink /> and we will perform this
      query for you.
    </span>
    <br />
    <ul>
      <li>- Purpose for the query</li>
      <li>- When you need the results</li>
      <li>- Criteria</li>
      <li>- Display fields</li>
    </ul>
  </div>
);